import { render } from "./StoryPiece.vue?vue&type=template&id=13a96d38"
import script from "./StoryPiece.vue?vue&type=script&lang=js"
export * from "./StoryPiece.vue?vue&type=script&lang=js"

import "./StoryPiece.vue?vue&type=style&index=0&id=13a96d38&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__